import * as L from 'leaflet';

export function getRedoControlOptions(afterClick: () => void): L.PM.CustomControlOptions & { disableByOtherButtons: boolean } {
  return {
    name: 'redo',
    block: 'custom',
    title: 'Undo',
    afterClick,
    toggle: false,
    disableByOtherButtons: false
  };
}
